module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_TI.19012660.txt";